// Return a random number
function rand () {
	return new Date().getTime();
}

// Return a random string
function randstr () {
	return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0,8);
}

function truncate(input,length) {
	if (typeof(input)=='string' && input.length > length) {
		return input.substring(0,length) + '...';
	}
	return input;
};

// Template engine, requires ejs_mod and jQuery
var tpl = (function(){
	return {
		run:function(s){
			var tpl = s.tpl || '';
			var data = s.data || {};
			var cb = s.cb || function(str){};
			this.get_tpl(tpl,function(tplstr){
				cb(new EJS({str:tplstr}).render(data));
			});
		},
		get_tpl:function(path,cb){
			var str = tpl.search_cache(path);
			if (str) {
				cb(str);
			}
			else {
				var request = new XMLHttpRequest();
				request.open('GET',path,true);
				request.onload = function() {
					if (this.status >= 200 && this.status < 400) {
						// Success!
						var resp = this.response;
						// Add to cache
						tpl.tpl_cache.push({
							path:path,
							data:resp
						});
						cb(resp);
					}
					else {
						// We reached our target server, but it returned an error
						cb('Error reading template');
					}
				};
				request.onerror = function() {
					// There was a connection error of some sort
					cb('Error reading template');
				};
				request.send();
			}
		},
		search_cache:function(path){
			var data = false;
			for (var i in tpl.tpl_cache) {
				if (tpl.tpl_cache[i]['path'] == path) {
					data = tpl.tpl_cache[i]['data'];
				}
				break;
			}
			if (data) {
				return data;
			}
			else {
				return false;
			}
		},
		tpl_cache:[]
	}
}());

// Debounce

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

// Pad

function pad(n) {
	return (n < 10) ? ("0" + n) : n;
}

// HTML encode

function ent(str){
	if (typeof(str)=='string') {
		str = str.replace(/"/g, '&quot;').replace(/'/g, '&apos;');
	}
	else {
		str = '';
	}
	return String(str);
}

function sanitizeHTML (text) {
	var element = document.createElement('div');
	element.innerText = text;
	return element.innerHTML;
}

// Format bytes to MB, KB etc.

function formatBytes(bytes,decimals) {
	if(bytes == 0) return '0 Bytes';
		var k = 1024,
			dm = decimals || 2,
			sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
			i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}